import {
  CheckIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from "~/ui";

export const toastIcons = {
  info: <InformationCircleIcon className="size-5" />,
  success: <CheckIcon className="size-5" strokeWidth={2} />,
  warning: <ExclamationCircleIcon className="size-5" />,
  error: <XCircleIcon className="size-5" />,
};
